import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { dropdownAction, setCashFormAction } from "../../redux/rootReducer";
import { CASH_FORM_INITIAL } from "../../redux/initialStateConstant";
import { updateCashThunk } from "../../redux/thunks/updateCashThunk";
import CalendarOffline from "../CalendarOffline/CalendarOffline";

const CashFrom = () => {
    const dispatch = useDispatch();
    const cash_form = useSelector(state => state.cash_form);
    const payment_methods = useSelector(state => state.payment_methods);
    const dropdown = useSelector(state => state.dropdown);

    const [openCalendar, setOpenCalendar] = useState(false);

    if (!cash_form.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setCashFormAction(CASH_FORM_INITIAL)) }/>
                        <div className="form__title">
                            { `${ cash_form.type === 'deposit' ? 'Внесение средств' : cash_form.type === 'withdrawal' ? 'Вывод средств' : '' }` }
                        </div>
                    </div>

                    <div className="form__field">
                        <div className="input__caption">{ `Дата ${ cash_form.type === 'deposit' ? 'внесения' : cash_form.type === 'withdrawal' ? 'вывода' : '' }` }</div>
                        <div className="input input--relative" onClick={ event => {
                            event.preventDefault();
                            event.stopPropagation();
                            setOpenCalendar('cash_date');
                        } }>
                            {
                                cash_form.date
                                    ?
                                    new Date(cash_form.date).toLocaleDateString('ru-Ru')
                                    :   ''
                            }
                        </div>
                        <CalendarOffline
                            handler={ date => {
                                dispatch(setCashFormAction({
                                    ...cash_form,
                                    date
                                }));

                                setOpenCalendar(null);
                            } }
                            open={ openCalendar === 'cash_date' }
                            close={ () => setOpenCalendar(null) }
                        />
                    </div>

                    {
                        payment_methods.length > 0
                            ?
                            <div className="form__field">
                                <div className="input__caption">Метод оплаты</div>
                                <div className="dropdown">
                                    <div className="input input--tick"
                                         onClick={ () => dropdown === 'payment_method' ? dispatch(dropdownAction(null)) : dispatch(dropdownAction('payment_method')) }
                                    >{ cash_form.payment_method.name }</div>
                                    <div className={ `dropdown__items ${ dropdown === 'payment_method' ? 'dropdown__items--open' : false }` }>
                                        {
                                            payment_methods.map(elem => {
                                                // Скрываем неактивные методы
                                                if (elem?.active === '0') return;
                                                return (
                                                    <div className="dropdown__item" key={ elem.id }
                                                         onClick={ () => {
                                                             dispatch(setCashFormAction({
                                                                 ...cash_form,
                                                                 payment_method: elem
                                                             }));
                                                             dispatch(dropdownAction(null));
                                                         } }
                                                    >{ elem.name }</div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            : false
                    }

                    <div className="form__field">
                        <div className="input__caption input__caption--required">Сумма</div>
                        <input type="number" className="input"
                            value={ cash_form.sum }
                            onInput={ event => dispatch(setCashFormAction({
                                ...cash_form,
                                sum: event.target.value
                            })) }
                        />
                    </div>

                    <div className="form__field">
                        <div className="input__caption">Описание</div>
                        <input type="text" className="input"
                               value={ cash_form.description }
                               onInput={ event => dispatch(setCashFormAction({
                                   ...cash_form,
                                   description: event.target.value
                               })) }
                        />
                    </div>

                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(updateCashThunk({
                                    id: cash_form.id,
                                    type: cash_form.type,
                                    sum: cash_form.sum,
                                    payment_method: cash_form.payment_method.id,
                                    description: cash_form.description,
                                    date: cash_form.date
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashFrom;